import { render, staticRenderFns } from "./Double.vue?vue&type=template&id=7fe9b2b4&scoped=true"
import script from "./Double.vue?vue&type=script&lang=js"
export * from "./Double.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9b2b4",
  null
  
)

export default component.exports